var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1120_2813)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50.5,
    r: 50,
    fill: "#FFA2C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7996 56.301C64.1496 56.926 63.8496 57.8485 64.0021 58.726L66.2246 71.026C66.4021 72.076 65.9771 73.1235 65.0996 73.726C64.2496 74.351 63.1246 74.426 62.1746 73.926L51.1021 68.151C50.6996 67.951 50.2746 67.8235 49.8521 67.8235H49.1746C48.9246 67.8485 48.7021 67.951 48.4996 68.0485L37.4246 73.851C36.8746 74.126 36.2496 74.226 35.6496 74.126C34.1496 73.826 33.1771 72.4235 33.4246 70.9485L35.6496 58.6485C35.7996 57.751 35.4996 56.851 34.8521 56.201L25.8246 47.451C25.0746 46.701 24.7996 45.6235 25.1521 44.626C25.4771 43.6485 26.3246 42.9235 27.3746 42.751L39.7996 40.9485C40.7496 40.8485 41.5746 40.276 41.9996 39.426L47.4746 28.201C47.5996 27.951 47.7746 27.7235 47.9771 27.526L48.1996 27.351C48.2996 27.2235 48.4496 27.126 48.6021 27.026L48.8746 26.926L49.2996 26.751H50.3521C51.3021 26.851 52.1271 27.4235 52.5521 28.2485L58.0996 39.426C58.4996 40.251 59.2746 40.801 60.1746 40.9485L72.5996 42.751C73.6496 42.901 74.5271 43.626 74.8746 44.626C75.1996 45.6235 74.9246 46.726 74.1496 47.451L64.7996 56.301Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1120_2813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default-avatar.698d7a0a79cb9b922c64a4e330589e77.svg";
export { ForwardRef as ReactComponent };